module.exports = __webpack_public_path__ + "rotary_sharp_left.svg?a78bfdef3403dacb4afd8ce915905557";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/rotary_sharp_left.svg
// module id = 210
// module chunks = 0